// rem等比适配配置文件
// 基准大小
let baseSize = 16;
function setRemUnit() {
  let scale;
  if (document.documentElement.clientWidth <= 950) {
    scale = document.documentElement.clientWidth / 375;
  } else if (document.documentElement.clientWidth >= 1920) {
    scale = 1;
  } else {
    scale = document.documentElement.clientWidth / 1920;
  }

  document.documentElement.style.fontSize =
    baseSize * Math.min(scale, 2) + "px";
}
// 初始化
setRemUnit();
// 改变窗口大小时重新设置 rem
window.addEventListener("resize", function () {
  setRemUnit();
});
